<template>
  <div>
    <Input
      @on-focus="openGroup = true"
      :value="name"
      readonly
      placeholder="请选择"
    ></Input>

    <Drawer
      :placement="placement"
      :closable="false"
      v-model="openGroup"
      width="450"
      draggable
      class="my-drawer"
    >
      <device-tool @car="reCar" :filter='filter' :filterGroup='filterGroup'></device-tool>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["name", "placement","filter",'filterGroup'],
  data() {
    return {
      openGroup: false,
    };
  },
  methods: {
    reCar(v) {
      console.log(v);
      this.openGroup = false;
      this.$emit("update:id", v.id);
      this.$emit("update:name", v.bind);
      this.$emit("update:deviceNo", v.deviceNo);
      this.$emit("update:useType", v.useType);
      this.$emit("car", v);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/selectDevice.vue